import { Card, CardContent } from '@/components/ui/card';
import { MaintenanceStatusBadge } from '@/products/maintenance/features/maintenance-status-badge';
import type { MaintenanceWorkOrderStatus } from '@gb-ticket/shared-types';

import { MAINTENANCE_PROTOCOL_COLUMN_CLASS } from '@/products/maintenance/features/protocol/protocol-wizard-layout';

export function ProtocolWizardContextCard({
  orderNumber,
  workOrderStatus,
  customerName,
  installationLabel,
  location,
  saveLabel,
}: {
  orderNumber: string;
  workOrderStatus: MaintenanceWorkOrderStatus;
  customerName: string;
  installationLabel: string;
  location: string;
  saveLabel: string;
}) {
  return (
    <Card className="w-full">
      <CardContent>
        <div className={MAINTENANCE_PROTOCOL_COLUMN_CLASS}>
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-lg font-semibold">{orderNumber}</p>
            <MaintenanceStatusBadge status={workOrderStatus} />
          </div>
          <dl className="mt-3 space-y-1 text-sm">
            <div>
              <dt className="sr-only">Kunde</dt>
              <dd>{customerName}</dd>
            </div>
            <div>
              <dt className="sr-only">Anlage</dt>
              <dd>{installationLabel}</dd>
            </div>
            <div>
              <dt className="sr-only">Ort</dt>
              <dd className="text-muted-foreground">{location}</dd>
            </div>
          </dl>
          {saveLabel ? (
            <p className="mt-3 text-sm text-muted-foreground" aria-live="polite">
              {saveLabel}
            </p>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
